import { Linking, Pressable, StyleSheet } from "react-native";

import { Block, Typography, spacing } from "@stepapp/ui";

type Props = {
  link?: string;
  label: string;
};

const FooterElement = ({ link, label }: Props) => {
  return link ? (
    <Pressable
      accessible
      android_ripple={{
        borderless: false,
      }}
      onPress={() => Linking.openURL(link)}
      style={styles.button}
    >
      <Typography type="white" variant="paragraph">
        {label}
      </Typography>
    </Pressable>
  ) : (
    <Block marginVertical={0.5} paddingVertical={0.5}>
      <Typography type="white" variant="paragraph">
        {label}
      </Typography>
    </Block>
  );
};

export default FooterElement;

const styles = StyleSheet.create({
  button: {
    marginRight: spacing.unit * 4,
    marginVertical: spacing.unit * 0.5,
    paddingVertical: spacing.unit * 0.5,
  },
});
